{
  "polygons": [
    [
      {
        "latitude": 45.4978913685552,
        "longitude": -73.5793770989859
      },
      {
        "latitude": 45.4977112249532,
        "longitude": -73.5795513545586
      },
      {
        "latitude": 45.4976758135195,
        "longitude": -73.5794753494702
      },
      {
        "latitude": 45.4978547592371,
        "longitude": -73.5793009819464
      },
      {
        "latitude": 45.4978913685552,
        "longitude": -73.5793770989859
      }
    ]
  ],
  "location": {
    "latitude": 45.4977295,
    "longitude": -73.5794476
  },
  "buildingCode": "K",
  "buildingName": "K Annex",
  "overview": [
    "The oldest of the Bishop annexes, this row house was built in 1890. Its Romanesque-inspired stonework and carved details — like rounded archways and a stone porch with balcony — make it especially striking.",
    "Acquired in 1970, the annex now houses offices for departments and unions."
  ],
  "accessibility": [],
  "address": "2150 Bishop St.",
  "campus": "SGW",
  "url": "https://www.concordia.ca/maps/buildings/k.html"
}
